var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _path14, _path15, _path16, _path17, _rect3, _path18, _path19, _path20, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.464844,
    y: 0.0390625,
    width: 350,
    height: 233,
    fill: "#7C92BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.865 106.355H247.436V162.926H201.865V106.355Z",
    fill: "#B66B25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.293 106.355H311.863V162.926H266.293V106.355Z",
    fill: "#B66B25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.705 100.938C218.705 98.7284 220.496 96.9375 222.705 96.9375H226.595C228.804 96.9375 230.595 98.7284 230.595 100.937V106.352H218.705V100.938Z",
    fill: "#B66B25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.133 100.938C283.133 98.7284 284.924 96.9375 287.133 96.9375H291.023C293.232 96.9375 295.023 98.7284 295.023 100.937V106.352H283.133V100.938Z",
    fill: "#B66B25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.865 100.938C201.865 98.7284 203.656 96.9375 205.865 96.9375H209.755C211.964 96.9375 213.755 98.7284 213.755 100.937V106.352H201.865V100.938Z",
    fill: "#B66B25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.973 100.938C299.973 98.7284 301.764 96.9375 303.973 96.9375H307.862C310.072 96.9375 311.862 98.7284 311.862 100.937V106.352H299.973V100.938Z",
    fill: "#B66B25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.195 106.355H244.766V162.926H199.195V106.355Z",
    fill: "#E9A363"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.623 106.355H309.194V162.926H263.623V106.355Z",
    fill: "#E9A363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.035 100.938C216.035 98.7284 217.826 96.9375 220.035 96.9375H223.925C226.134 96.9375 227.925 98.7284 227.925 100.937V106.352H216.035V100.938Z",
    fill: "#E9A363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.463 100.938C280.463 98.7284 282.254 96.9375 284.463 96.9375H288.353C290.562 96.9375 292.353 98.7284 292.353 100.937V106.352H280.463V100.938Z",
    fill: "#E9A363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.195 100.938C199.195 98.7284 200.986 96.9375 203.195 96.9375H207.085C209.294 96.9375 211.085 98.7284 211.085 100.937V106.352H199.195V100.938Z",
    fill: "#E9A363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.303 100.938C297.303 98.7284 299.094 96.9375 301.303 96.9375H305.193C307.402 96.9375 309.193 98.7284 309.193 100.937V106.352H297.303V100.938Z",
    fill: "#E9A363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.965 106.352H279.7V162.922H270.965V106.352Z",
    fill: "#E19752"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 233.207,
    y: 89.1523,
    width: 45.5705,
    height: 73.7667,
    fill: "#A3673C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.047 83.7383C250.047 81.5291 251.838 79.7383 254.047 79.7383H257.937C260.146 79.7383 261.937 81.5291 261.937 83.7383V89.1529H250.047V83.7383Z",
    fill: "#A3673C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.207 83.7383C233.207 81.5291 234.998 79.7383 237.207 79.7383H241.097C243.306 79.7383 245.097 81.5291 245.097 83.7383V89.1529H233.207V83.7383Z",
    fill: "#A3673C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.889 83.7383C266.889 81.5291 268.68 79.7383 270.889 79.7383H274.779C276.988 79.7383 278.779 81.5291 278.779 83.7383V89.1529H266.889V83.7383Z",
    fill: "#A3673C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M228.838 106.352H237.573V162.922H228.838V106.352Z",
    fill: "#E19752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 231.41,
    y: 89.1523,
    width: 45.5705,
    height: 73.7667,
    fill: "#EABF98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248.25 83.7383C248.25 81.5291 250.041 79.7383 252.25 79.7383H256.14C258.349 79.7383 260.14 81.5291 260.14 83.7383V89.1529H248.25V83.7383Z",
    fill: "#EABF98"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231.41 83.7383C231.41 81.5291 233.201 79.7383 235.41 79.7383H239.3C241.509 79.7383 243.3 81.5291 243.3 83.7383V89.1529H231.41V83.7383Z",
    fill: "#EABF98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.092 83.7383C265.092 81.5291 266.883 79.7383 269.092 79.7383H272.982C275.191 79.7383 276.982 81.5291 276.982 83.7383V89.1529H265.092V83.7383Z",
    fill: "#EABF98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27331)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.727,
    y: 103.98,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27331)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.246,
    y: 103.98,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_569_27331)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.623,
    y: 103.98,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_569_27331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.203 145.155C241.203 137.98 247.019 132.164 254.194 132.164V132.164C261.369 132.164 267.185 137.98 267.185 145.155V162.796C267.185 162.864 267.13 162.918 267.062 162.918H241.326C241.258 162.918 241.203 162.864 241.203 162.796V145.155Z",
    fill: "#B77A41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27331",
    x: 235.727,
    y: 103.98,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27331",
    x: 249.246,
    y: 103.98,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_569_27331",
    x: 263.623,
    y: 103.98,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_569_27331",
    x: 241.203,
    y: 132.164,
    width: 26.1824,
    height: 30.9539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.403922 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27331"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea06);
export default __webpack_public_path__ + "static/media/sea_06.a05eb34bf9dcb235911bbff4ad3dfec2.svg";
export { ForwardRef as ReactComponent };